module.exports = __webpack_public_path__ + "img/songlv.54b2e92d.png";